/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_result.csvの1行分のデータ
 * @export
 * @interface SchemasCustomCalcSimResultData
 */
export interface SchemasCustomCalcSimResultData {
    /**
     * 
     * @type {string}
     * @memberof SchemasCustomCalcSimResultData
     */
    datetime: string;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    wlevel?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    flow?: number;
    /**
     * 降水量
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    r?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    ruika?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    wlevelNodam?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    flowNodam?: number;
    /**
     * 
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    qinAll?: number;
    /**
     * 放流量
     * @type {number}
     * @memberof SchemasCustomCalcSimResultData
     */
    qoutAll?: number;
}

/**
 * Check if a given object implements the SchemasCustomCalcSimResultData interface.
 */
export function instanceOfSchemasCustomCalcSimResultData(value: object): value is SchemasCustomCalcSimResultData {
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    return true;
}

export function SchemasCustomCalcSimResultDataFromJSON(json: any): SchemasCustomCalcSimResultData {
    return SchemasCustomCalcSimResultDataFromJSONTyped(json, false);
}

export function SchemasCustomCalcSimResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchemasCustomCalcSimResultData {
    if (json == null) {
        return json;
    }
    return {
        
        'datetime': json['datetime'],
        'wlevel': json['wlevel'] == null ? undefined : json['wlevel'],
        'flow': json['flow'] == null ? undefined : json['flow'],
        'r': json['R'] == null ? undefined : json['R'],
        'ruika': json['Ruika'] == null ? undefined : json['Ruika'],
        'wlevelNodam': json['wlevel_nodam'] == null ? undefined : json['wlevel_nodam'],
        'flowNodam': json['flow_nodam'] == null ? undefined : json['flow_nodam'],
        'qinAll': json['Qin_all'] == null ? undefined : json['Qin_all'],
        'qoutAll': json['Qout_all'] == null ? undefined : json['Qout_all'],
    };
}

export function SchemasCustomCalcSimResultDataToJSON(json: any): SchemasCustomCalcSimResultData {
    return SchemasCustomCalcSimResultDataToJSONTyped(json, false);
}

export function SchemasCustomCalcSimResultDataToJSONTyped(value?: SchemasCustomCalcSimResultData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datetime': value['datetime'],
        'wlevel': value['wlevel'],
        'flow': value['flow'],
        'R': value['r'],
        'Ruika': value['ruika'],
        'wlevel_nodam': value['wlevelNodam'],
        'flow_nodam': value['flowNodam'],
        'Qin_all': value['qinAll'],
        'Qout_all': value['qoutAll'],
    };
}

